export default "__VITE_ASSET__vC4zlmYh__"